import React, { useState, useEffect } from "react";
import { Button, Modal } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import { successMsgDuration } from "../../constants/config";
import { useLogout } from "../../utilities";

const errorColor = "#FFE0DF";
const successColor = "#E5FFDA";

export default function ModalMessage(props) {
  // modal message box
  // for error messages (type="danger"), red background, large
  // for success message (type="success"), green background, small
  // props:
  //      type (string): one of bootstrap's variant types -> determines background color, default is white
  //      message (string): the alert message to be displayed
  //      autoClose (boolean): if true, close automatically after 1.5 seconds
  //      linkPath (string): path button should link to
  //      setErrorMsg: function to set the error message in parent component
  //      setSuccessMsg: function to set the success message in parent component
  const [show, setShow] = useState(true);
  const navigate = useNavigate();
  const logout = useLogout();

  const { autoClose, setSuccessMsg } = props;

  useEffect(() => { 
    if (autoClose) {
      const timer = setTimeout(() => {
        setShow(false);
        setSuccessMsg("");
      }, successMsgDuration);
      return () => clearTimeout(timer);
    }
  }, [autoClose, setSuccessMsg]);

  return (
    <Modal
      size={props.type === "success" ? "sm" : "md"}
      show={show}
      onHide={() => setShow(false)}
      backdrop={props.type === "success" ? false : "static"}
      keyboard={false}
      centered
    >
      <Modal.Header
        // closeButton
        style={{
          background:
            props.type === "danger"
              ? errorColor
              : props.type === "success"
              ? successColor
              : "",
        }}
      >
        <Modal.Title>
          {props.type === "danger"
            ? "Error"
            : props.type === "success"
            ? "Success"
            : "Please confirm"}
        </Modal.Title>
      </Modal.Header>
      <Modal.Body
        style={{
          background:
            props.type === "danger"
              ? errorColor
              : props.type === "success"
              ? successColor
              : "",
        }}
      >
        {props.message}
      </Modal.Body>

        <Modal.Footer
          style={{
            background:
              props.type === "danger"
                ? errorColor
                : props.type === "success"
                ? successColor
                : "",
          }}
        >
        {props.showLogoutButton && 
        <Button variant="danger" onClick={() => {
          props.setShowLogoutMsg(false);
          setShow(false);
          logout();
        }}>
        Logout</Button>}
        {props.confirmButton && 
        <Button variant="danger" onClick={() => {
          props.handleConfirm(); 
          props.setShowAlertMsg(false); 
          setShow(false); 
        }}>Confirm</Button>
        
        }
          {props.linkPath && (
            <Button
              variant="dark"
              // href={props.linkPath}
              onClick={() =>
                navigate(
                  props.linkPath,
                  props.nextPageLink && { state: { data: props.nextPageLink } }
                )
              }
            >
              {props?.buttonText || "Go to"}
            </Button>
          )}
          <Button
            variant="light"
            onClick={() => {
              if(props.showLogoutButton ){
                props.setShowLogoutMsg(false); 
              } else if(props.confirmButton){
                props.setShowAlertMsg(false); 
              } else {
              props.type && props.type === "danger"
                ? props.setErrorMsg?.("")
                : props.setSuccessMsg?.("");
              }
              setShow(false);
            }}
          >
            {props?.confirmButton ? "Cancel" : "Close"}
          </Button>
        </Modal.Footer>
    
    </Modal>
  );
}
